import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const PageContext = React.createContext({});

export const PageContextProvider = ({ pageContext, children }) => {
  const { i18n } = useTranslation();
  i18n.changeLanguage(pageContext.lang);
  // useEffect(() => {
  //   effect
  // }, [input])

  return <>{children}</>;
};

export const usePageContext = () => React.useContext(PageContext);